import { render, staticRenderFns } from "./social-media-icons.vue?vue&type=template&id=7378e23a&scoped=true&"
import script from "./social-media-icons.vue?vue&type=script&lang=js&"
export * from "./social-media-icons.vue?vue&type=script&lang=js&"
import style0 from "./social-media-icons.vue?vue&type=style&index=0&id=7378e23a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7378e23a",
  null
  
)

export default component.exports